<div class="time-series-chart-container">
  <mat-card class="chart-card">
    <mat-card-content>
      <div class="title-toggle">
        @if (hasData()) {
          <h2 class="widget-title">
            <mat-icon>bar_chart</mat-icon>
            {{
              viewMode === 'monthly'
                ? `Daily Text + Voice Interactions by Month`
                : `Weekly Text + Voice Interactions`
            }}
          </h2>

          <mat-button-toggle-group
            [(ngModel)]="viewMode"
            (change)="onViewChange()"
          >
            <mat-button-toggle value="monthly"> Monthly </mat-button-toggle>
            <mat-button-toggle value="weekly"> Weekly </mat-button-toggle>
          </mat-button-toggle-group>
        }
      </div>

      <!-- Loading State -->
      @if (isLoading) {
        <div class="loading-state">
          <mat-progress-spinner
            diameter="50"
            mode="indeterminate"
          ></mat-progress-spinner>
          <span>Loading chart data...</span>
        </div>
      }

      <!-- No Data State -->
      @if (!isLoading && !hasData()) {
        <div class="no-data-state">
          <mat-icon>info</mat-icon>
          <span
            >No time-series data available. Please select a date range to view
            trends.</span
          >
        </div>
      }

      <!-- Monthly Histogram Charts -->
      @if (viewMode === 'monthly') {
        @if (!isLoading && hasData()) {
          <div class="monthly-charts-container">
            @for (monthChart of monthlyCharts; track monthChart.month) {
              <div class="month-chart">
                <h3 class="month-title">{{ monthChart.month }}</h3>
                <div class="chart-wrapper">
                  <canvas
                    baseChart
                    [data]="monthChart.chartData"
                    [options]="chartOptions"
                    [type]="chartType"
                  ></canvas>
                </div>
              </div>
            }
          </div>
        }
      }

      @if (viewMode === 'weekly') {
        <!--Weekly chart-->
        @if (!isLoading && hasData()) {
          <div class="weekly-charts-container">
            <div class="weekly-chart">
              <div class="weekly-wrapper">
                <canvas
                  baseChart
                  [data]="weeklyCharts[0].chartData"
                  [options]="chartOptions"
                  [type]="chartType"
                ></canvas>
              </div>
            </div>
          </div>
        }
      }
    </mat-card-content>
  </mat-card>
</div>
